import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { UserApiService } from '../../user-api.service';
import { Subscription, of } from 'rxjs';
import { SiteService } from 'src/app/services/site.service';
import { log } from 'console';
import { distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { slideTrigger } from 'src/app/events-calendar/common/animation/triggers/slideTrigger';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-edit-user-group',
  templateUrl: './add-edit-user-group.component.html',
  styleUrls: ['./add-edit-user-group.component.css'],
  animations: [
    slideTrigger,
    trigger('zipper', [
      state('collapsed', style({
        height: '0px',
        overflow: 'hidden',
        paddingTop: '0px',
        paddingBottom: '0px'
      })),
      state('expanded', style({
        height: '*',
        paddingTop: '*',
        paddingBottom: '*'
      })),
      transition('collapsed <=> expanded', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})
export class AddEditUserGroupComponent implements OnInit {
  idOfOneGroup;
  groupTypes: any;

  form: FormGroup;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private userService: UserApiService,
    public siteService: SiteService,
    private snotifyService: ToastrService,
    @Optional() public dialogRef: MatDialogRef<AddEditUserGroupComponent>, // optional
  @Optional() @Inject(MAT_DIALOG_DATA) public data: any // optional
  ) {
  this.isModal = !!dialogRef;
     }
  id = 0;
  siteCultures: any[] = [];
  isEditGroup: boolean = false;
  getUsedSiteCulturesSubscription: Subscription;
  activeTab: any;
  activeInnerTab = 1;
  ngOnDestroy(): void {
    if (this.getUsedSiteCulturesSubscription)
      this.getUsedSiteCulturesSubscription.unsubscribe()
  }
isModal: boolean = false;

  ngOnInit() {

    this.getGroupTypes()
    this.getUsedSiteCulturesSubscription = this.siteService.getUsedSiteCultures(2)
      .pipe(
        switchMap((res) => {
          this.siteCultures = res;
          console.log(res ,'eesssssssssssssssss');
          
          return this.route.paramMap;
        })
        ,
        switchMap((params) => {
          if (params.get('id')) {
            this.isEditGroup = true;
            this.id = +params.get('id')

            return of(params);
          }
          else { return of(null) }
        })
        , switchMap((params: ParamMap) => {
          if (params) {
            return this.getGroupById(params.get('id'));
            // return this.getGroupById(params.get('id'))
          }
          else { return of(null) }

        })
      )
      .subscribe(
        (res: any) => {
          console.log(res, 'INIT');
          this.pageInitialize(res)

        }
      )
      this.form = new FormGroup({
  id: new FormControl(0),
  name: new FormControl(''),
  customerGroupDetails: new FormArray([]),
  description: new FormControl(''),
  isActive: new FormControl(false),
  email: new FormControl('', [Validators.email]),
  groupTypeId: new FormControl(0),
  fireBaseTopic: new FormControl(''),
  maxSessions: new FormControl(0, [Validators.required, Validators.min(1)]),
  passwordExpiryInDays: new FormControl(0, [Validators.required, Validators.min(1)]),
  EnableTwoFactorAuthentication: new FormControl(false)
});

  }
  pageInitialize(group) {
       if (!group) {
      group = {};
    }
    this.form = new FormGroup({
      id: new FormControl(this.id ? this.id : 0),
      name: new FormControl(""),
      customerGroupDetails: new FormArray([]),
      description: new FormControl(""),
      isActive: new FormControl(this.customGroup ? this.customGroup.isActive : false),
      email: new FormControl(this.customGroup ? this.customGroup.email : "", [Validators.email]),
      groupTypeId: new FormControl(this.customGroup ? this.customGroup.groupTypeId : 0),
      fireBaseTopic: new FormControl(this.customGroup ? this.customGroup.fireBaseTopic : ""),
      maxSessions: new FormControl(this.customGroup ? this.customGroup.maxSessions : 0, [Validators.required, Validators.min(1)]),
      passwordExpiryInDays: new FormControl(this.customGroup ? this.customGroup.passwordExpiryInDays : 0, [Validators.required, Validators.min(1)]),
      EnableTwoFactorAuthentication: new FormControl(this.customGroup ? this.customGroup.enableTwoFactorAuthentication : false)
    });


    this.initializeCulturesForm(group);
  }
  updateActiveTab(v) {
    this.activeTab = this.activeTab == v ? null : v;
    this.activeInnerTab = 1;
  }
  initializeCulturesForm(group) {
    const formArray = this._customerGroupDetails;
    if (this.siteCultures && this.siteCultures.length) {
      for (let i = 0; i < this.siteCultures.length; i++) {
        let foundCulture;
        const cultureId = this.siteCultures[i].id;
        const cultureCode = this.siteCultures[i].name;
               if (
          group &&
          group.customerGroupDetails &&
          group.customerGroupDetails.length
        ) {
          foundCulture = group.customerGroupDetails.find(
            (el) => el.cultureId == cultureId
          );
        }
               console.log(foundCulture, "foundCulture");

        const cultureInformation = new FormGroup({
          id: new FormControl(this.id ? this.id : 0),
          name: new FormControl(foundCulture ? foundCulture.name : "", [Validators.required]),
          description: new FormControl(foundCulture ? foundCulture.description : "", [Validators.required]),
          cultureId: new FormControl(foundCulture ? foundCulture.cultureId : cultureId),
          cultureCode: new FormControl(foundCulture ? foundCulture.cultureCode : cultureCode),
          // status: new FormControl(foundCulture && foundCulture.name ? true : false),
        })
        formArray.push(cultureInformation);
      }

      formArray.updateValueAndValidity();
      this.isPageLoaded = true;

      // for (let index in this.siteCultures) {
      //        //   if (index == "move") {
      //     continue;
      //   }
      //   if (this._customerGroupDetails.controls[index].get('status').value) {
      //     this._customerGroupDetails.controls[index].get('name').setValidators([Validators.required]);
      //     this._customerGroupDetails.controls[index].get('name').updateValueAndValidity();
      //     this._customerGroupDetails.controls[index].get('description').setValidators([Validators.required, Validators.pattern(/^\S*$/)]);
      //     this._customerGroupDetails.controls[index].get('description').updateValueAndValidity();
      //   }
      //   else {
      //     this._customerGroupDetails.controls[index].get('name').clearValidators();
      //     this._customerGroupDetails.controls[index].get('name').updateValueAndValidity();
      //     this._customerGroupDetails.controls[index].get('description').clearValidators();
      //     this._customerGroupDetails.controls[index].get('description').updateValueAndValidity();
      //   }
      //   this._customerGroupDetails.controls[index].get('status').valueChanges
      //     .pipe(
      //       distinctUntilChanged()
      //     )
      //     .subscribe(
      //       status => {
      //         if (status) {
      //           this._customerGroupDetails.controls[index].get('name').setValidators([Validators.required]);
      //           this._customerGroupDetails.controls[index].get('name').updateValueAndValidity();
      //           this._customerGroupDetails.controls[index].get('description').setValidators([Validators.required]);
      //           this._customerGroupDetails.controls[index].get('description').updateValueAndValidity();
      //         }
      //         else {
      //           this._customerGroupDetails.controls[index].get('name').clearValidators();
      //           this._customerGroupDetails.controls[index].get('name').updateValueAndValidity();
      //           this._customerGroupDetails.controls[index].get('description').clearValidators();
      //           this._customerGroupDetails.controls[index].get('description').updateValueAndValidity();

      //         }
      //       }
      //     )
      //   this._customerGroupDetails.controls[index].patchValue({ status: this._customerGroupDetails.controls[index].get('status').value });

      // }
      console.log(this.form, 'FORM ');
    }
  }
  isPageLoaded: boolean = false;

  addGroup() {
    // let isPublishedCulture = this._customerGroupDetails.controls.some(el => el.get('status').value == true)
    // if (!isPublishedCulture) {
    //   this.snotifyService.error('Publish at least one culture')
    //   console.log("not published");

    //   return;
    // }
    if (this.form.invalid) {

      this.form.markAllAsTouched();
      return;
    }

    if (this._id.value) {
      this.userService.editCustomergroups({ ...this.form.value, id: this._id.value }).subscribe((res) => {
        this.snotifyService.success("Groups has been edited successfully");
        this.router.navigate(['/users-permissions/users/user-group'])
      });
    }
    else {
      this.userService.addCustomergroups(this.form.value).subscribe
        ((res) => {
          // id of group number
          if (res) {
            // this.snotifyService.success('', 'Saved Successfully');
            // this.router.navigate(['/users-permissions/users/user-group'])
              this.snotifyService.success('Saved Successfully');
      if (this.isModal) {
       this.dialogRef.close('done');
      } else {
        this.router.navigate(['/users-permissions/users/user-group']); // redirect if page
      }
          }
        }, error => {
          this.snotifyService.error(error.message, 'Something Went Wrong ')
        })
    }
  }
  cancel() {
    // this.router.navigate(['/users-permissions/users/user-group'])
     if (this.isModal) {
    this.dialogRef.close();
  } else {
    this.router.navigate(['/users-permissions/users/user-group']);
  }
  }
  customGroup: any;
  getGroupById(groupId) {
    return this.userService.getCustomerGroupsById(groupId).pipe(tap(res => {
      this.customGroup = res;
    }))

  }
  getData(event) {
    return this.siteCultures.find(x => x.id == event.value.cultureId).name;
  }

  getGroupTypes() {
    let prams = {
      pagination: {
        start: 0,
        number: 10,
      },
      search: {
        predicateObject: {
          Name: '',
          Status: null
        }
      },
      sort: {
        predicate: "string",
        reverse: true
      }
    }
    this.userService.getAllUserGroupTypes(prams).subscribe((res: any) => { this.groupTypes = res.data; }, error => {
      this.snotifyService.error(error.message, error.message ? error.message : 'Something Went Wrong ')
    })
  }
  // get _getName() { return this.form.get('name') }
  // get _getDescription() { return this.form.get('description') }
  get _getEmail() { return this.form.get('email') }
  get _active() { return this.form.get('isActive') }

  get _getfireBaseTopic() { return this.form.get('fireBaseTopic') }
  get _id() { return this.form.get('id') }
  get _getMaxSessions() { return this.form.get('maxSessions') }
  get _getPasswordExpiryInDays() { return this.form.get('passwordExpiryInDays') }
  get _getGroupTypeId() { return this.form.get('groupTypeId') }
  get _customerGroupDetails() {
    return this.form?.get("customerGroupDetails") as FormArray
  }


}
